import { Duration, ToHumanDurationOptions } from 'luxon';

import { getLocale } from '@phoenix/core/frontend/shared/util/locales/locales';

export const humanizeDuration = (minutes: number, options?: ToHumanDurationOptions) => {
  try {
    return Duration.fromObject({ minutes }, { locale: getLocale().RFC5646 }).toHuman({ unitDisplay: 'short', ...options });
  } catch {
    return minutes;
  }
};
